import { render, staticRenderFns } from "./IdentificationFocusHandler.vue?vue&type=template&id=3d3caf93"
import script from "./IdentificationFocusHandler.vue?vue&type=script&lang=js"
export * from "./IdentificationFocusHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports